const { useState } = require('react');
const { useI18n } = require('nordic/i18n');
const { Button } = require('@andes/button');
const { Modal } = require('@andes/modal');
const { Title } = require('@andes/typography');

const translate = require('../../../../translation');
const { generateIcon } = require('../../../../utils/icons');

const ModalShippingAddress = ({
  isMobile,
  address,
  handleFirstAction,
  handleSecondaryAction,
  userType,
  isOpen,
}) => {
  const { i18n } = useI18n();
  const translations = translate(i18n);
  const [isOpened, setIsOpened] = useState(isOpen);
  const userTypeLabel = {
    guest: { label: translations.ENTER_ANOTHER_ADDRESS },
    logged: { label: translations.CHOOSE_ANOTHER_ADDRESS },
  };

  const actionPrimary = (
    <Button
      onClick={() => {
        setIsOpened(false);
        handleFirstAction?.();
      }}
    >
      {translations.CONFIRM_ADDRESS}
    </Button>
  );

  const actionSecondary = (
    <Button
      onClick={() => {
        setIsOpened(false);
        handleSecondaryAction?.();
      }}
      hierarchy="quiet"
    >
      {userTypeLabel[userType].label}
    </Button>
  );

  return (
    <Modal
      closable={false}
      open={isOpened}
      className="shipping-generics"
      type={isMobile ? 'card' : 'small'}
      media={{
        asset: (
          <div className="shipping-address">
            {generateIcon({ type: 'icon_pin' })}
          </div>
        ),
      }}
      title={
        <section className="d-flex d-flex-justify-center modal-content-area ">
          <Title
            size="m"
            className="text-center"
            component="div"
            srLabel={
              translations.CONFIRM_THE_ADDRESS_WHERE_YOU_WILL_RECEIVE_THE_PURCHASE
            }
          >
            {
              translations.CONFIRM_THE_ADDRESS_WHERE_YOU_WILL_RECEIVE_THE_PURCHASE
            }
          </Title>
        </section>
      }
      actions={{
        primary: actionPrimary,
        secondary: actionSecondary,
      }}
      srLabel={
        translations.CONFIRM_THE_ADDRESS_WHERE_YOU_WILL_RECEIVE_THE_PURCHASE
      }
    >
      <section className="d-flex d-flex-justify-center text-center">
        {address}
      </section>
    </Modal>
  );
};

module.exports = { ModalShippingAddress };
